
window.shares = function (types, pt_img, url){
    if(!pt_img) pt_img='';
    if(url == "" || url == undefined || url == 'undefined'){
        var url = location.href;//window.location.hostname;
    }
    switch(types){
        case "fb":
            window.open('http://www.facebook.com/share.php?u='.concat(encodeURIComponent(url)) );
        break;
        case "tr":
            window.open('https://twitter.com/intent/tweet?original_referer='+encodeURIComponent(url)+'&url='+encodeURIComponent(url));
            // window.open('http://twitter.com/home/?status='.concat(encodeURIComponent(document.title)) .concat('') .concat(encodeURIComponent(url)))
        break;
        case "gp":
            window.open('https://plus.google.com/share?url='.concat(encodeURIComponent(url)) )
        break;
        case "sn":
            window.open('https://v.t.sina.com.cn/share/share.php?url=' + encodeURIComponent(url) + '&title=' + encodeURIComponent(document.title));
        break;
        case "pt":
            window.open('https://pinterest.com/pin/create/like/?url=' + encodeURIComponent(url) +'&media='+encodeURIComponent(pt_img) + '&description=' + encodeURIComponent(document.title));
        break;
        case "line":
            // https://line.naver.jp/R/msg/text/?{msg}
            // msg = 在LINE裡面顯示的內容
            // 僅限行動裝置
            window.open('https://social-plugins.line.me/lineit/share?url='+encodeURIComponent(url));
        break;
    }
    return false;
} // end of function

window.addToGoogleCalendar = function(element,type){

    let title  = $(element).data('title');
    let start  = $(element).data('start');
    let end    = $(element).data('end');

    let google_string  = "";
    let outlook_string = "";

    if(start !== "" && start !== undefined && end !== "" && end !== undefined){
        google_string += "&dates="+start+'/'+end;
        outlook_string += "&startdt="+start;
    }

    switch(type) {
        case "outlook":
            window.open('https://outlook.office.com/calendar/0/deeplink/compose?subject=' + encodeURIComponent(title) + '&allday=true&path=%2Fcalendar%2Faction%2Fcompose&rru=addevent' + outlook_string);
        break;
        case "google":
            window.open('https://www.google.com/calendar/render?action=TEMPLATE&text=' + encodeURIComponent(title) + google_string);
        break;
    }
    return false;
}// end of function

window.bindCalendarClickEvent = function(){
    let width = $(window).width();
    if(width <= 1000){
        $('.rd_calendar_click').on('click',function(){
            $(this).find('.rd_calendar_box').toggleClass('show');
        });
    }else{
        $('.rd_calendar_click').unbind('click');
    }
}// end of function

window.bindFilterYearClickEvent = function(){
    let width = $(window).width();
    if(width <= 1000){
        $('.rd_year_show').on('click',function(){
            if($(this).closest('.rd_year_box').find('.rd_year_open').is(':hidden') == true){
                $(this).closest('.rd_year_box').find('.rd_year_open').show();
            }else{
                $(this).closest('.rd_year_box').find('.rd_year_open').hide();
            }
            return false;
        });
    }else{
        $('.rd_year_show').unbind('click');
        $('.rd_year_open').removeAttr('style');
    }
}// end of function

window.gotoURL = function (url,type){
    if(type == "open"){
        window.open(url);
    }else{
        window.location.href=url;
    }
} // end of function

// 鎖捲軸
// 例: 如果要鎖 body:
// var body = $('body');
// lockScroll(body);
window.lockScroll = function (target) {
    var scroll_top = $(window).scrollTop();
    var lock_count = $(target).data('lock_count');

    if (typeof lock_count === 'undefined' || lock_count === 0) {
        $(target).data('lock_count', 1);

        target.data('scroll_style', target.attr('style'));
        target.data('scroll_top'  , scroll_top);
        target.css({"overflow":"hidden", "position":"fixed", "top": (scroll_top * -1)+"px"});
    } else {
        $(target).data('lock_count', lock_count + 1);
    } // end of if

} // end of function

// 開捲軸 - 如果鎖了3次, 需要呼叫此　function 3 次後才會解鎖
//
// target　要解開鎖的目標
// unlock_all 強制解鎖, 無視鎖被加了幾次
window.unlockScroll = function (target, unlock_all) {

    var lock_count = $(target).data('lock_count');

    if (typeof lock_count === 'undefined' || lock_count === 0) {
        lock_count = 0;
        $(target).data('lock_count', 0);
    } else {
        lock_count = lock_count - 1;
        $(target).data('lock_count', lock_count);
    } // end of if

    if (lock_count === 0 || (typeof unlock_all !== 'undefined' && unlock_all === true)) {
        var scroll_top   = target.data('scroll_top'  );
        var scroll_style = target.data('scroll_style');

        if (scroll_style) {
            target.attr('style', scroll_style);
        } else {
            target.removeAttr('style');
        }

        $(window).scrollTop(scroll_top);
    } // end of if

} // end of function

window.new_eval = function(string){
    return new Function('return ' + string)();
}

window.checkElementsAnimateEvent = function(){
    $(".rd_animate_box[is_animate='0']").each(function() {
        if($(this).visible(true)){
            $(this).attr('is_animate', 1);
            if($(this).hasClass('ir_box')){
                initInvestorSwiper();
            }
        }
    });
    $('.rd_animate_item').each(function(){
        if($(this).visible(true) && $(this).attr('switch') !== '1') {
            let animate = $(this).attr('animate');
            $(this).addClass(animate);
            $(this).attr('switch', 1);
        }
    });
    $('.rd_animate_chart').each(function(){
        if($(this).visible(true) && $(this).attr('switch') !== '1') {
            let chart_name    = $(this).data('chart');
            let current_chart = new_eval(chart_name);
            current_chart.init();
            $(this).attr('switch', 1);
        }
    });
}// end of function

// For date format;
Date.prototype.date_format = function () {
    return this.getFullYear() +"-"+ (((this.getMonth()+1) < 10)?"0":"") + (this.getMonth()+1) +"-"+ ((this.getDate() < 10)?"0":"") + this.getDate();
}

// For time format
Date.prototype.time_format = function () {
    return ((this.getHours() < 10)?"0":"") + this.getHours() +":"+ ((this.getMinutes() < 10)?"0":"") + this.getMinutes() +":"+ ((this.getSeconds() < 10)?"0":"") + this.getSeconds();
}

window.checkNumberAnimateEvent = function(){
    $('.rd_animate_number').each(function(){
        if($(this).visible(true) && $(this).attr('switch') !== '1') {
            $(this).html('');
            setAnimateNumber(this);
            $(this).attr('switch', 1);
        }
    });
    $('.rd_rolling_number').each(function(){
        if($(this).visible(true) && $(this).attr('switch') !== '1') {
            $(this).numberAnimate();
            $(this).attr('switch', 1);
        }
    });
}// end of function

window.checkRevenueAnimateEvent = function(){
    $('.rd_revenue_box').each(function(){
        if($(this).visible(true) && $(this).attr('show') === '1'){
            $(this).find('.rd_revenue_animate').each(function(){
                if($(this).visible(true) && $(this).attr('switch') !== '1') {
                    $(this).html('');
                    setAnimateNumber(this);
                    $(this).attr('switch', 1);
                }
            });
            $(this).find('.rd_revenue_rolling').each(function(){
                if($(this).visible(true) && $(this).attr('switch') !== '1') {
                    $(this).numberAnimate();
                    $(this).attr('switch', 1);
                }
            });
        }
    })
}// end of function

window.checkPerformanceAnimateEvent = function(){
    $('.rd_performance_box').each(function(){
        if($(this).visible(true) && $(this).attr('show') === '1'){
            $(this).find('.rd_performance_rolling').each(function(){
                if($(this).visible(true) && $(this).attr('switch') !== '1') {
                    $(this).numberAnimate();
                    $(this).attr('switch', 1);
                }
            });
        }
    })
}// end of function

window.setAnimateNumber = function(element) {

    let mode    = $(element).data('mode') !== undefined ? $(element).data('mode'): null;
    let number  = $(element).data('number') !== undefined ? $(element).data('number'): 0;
    let decimal = $(element).data('decimal') !== undefined ? $(element).data('decimal'): 0;
    let speed   = $(element).data('speed') !== undefined ? $(element).data('speed'): 1250;

    if(mode === 'format'){
        animateNumberFormat($(element), number, speed);
    }else if(mode === 'percent'){
        animateNumberPercent($(element), number, speed);
    }else if(mode === 'float'){
        animateNumberFloat($(element), number, decimal, speed);
    }else{
        animateNumberNormal($(element), number, speed);
    }
}

window.animateNumberNormal = function(element, number, speed) {
    element.stop().animateNumber(
        {
            number: number
        },
        {
            easing: 'swing',
            duration: speed
        }
    );
}
window.animateNumberFormat = function(element, number, speed) {
    element.stop().animateNumber(
        {
            number: number ,
            numberStep: $.animateNumber.numberStepFactories.separator(',')
        },
        {
            easing: 'linear',
            duration: speed
        }
    );
}
window.animateNumberPercent = function(element, number, speed) {
    element.stop().animateNumber(
        {
            number: number ,
            numberStep: $.animateNumber.numberStepFactories.append(' %')
        },
        {
            easing: 'swing',
            duration: speed
        }
    );
}
window.animateNumberFloat = function(element, number, decimal, speed) {

    let decimal_places = decimal;
    let decimal_factor = decimal_places === 0 ? 1 : Math.pow(10, decimal_places);

    element.stop().animateNumber(
        {
            number: number ,
            numberStep: function(now, tween) {

                let floored_number = Math.floor(now*decimal_factor) / decimal_factor,
                    target = $(tween.elem);

                if (decimal_places > 0) {
                    // force decimal places even if they are 0
                    floored_number = floored_number.toFixed(decimal_places);

                    // replace '.' separator with ','
                    floored_number = floored_number.toString().replace('.', '.');
                }
                target.text(floored_number);
            }
        },
        {
            easing: 'swing',
            duration: speed
        }
    );
}

window.loadImages = function(images) {
    return new Promise((resolve, reject) => {
        (function loadEach(images, index) {
            if (index < images.length) {
                let img = new Image();
                img.src = images[index];
                images[index] = img;
                images[index].onload = function() {
                    loadEach(images, ++index);
                };
                images[index].onerror = (err) => reject(err);
            } else {
                resolve(images);
            }
        })(images, 0)
    });
}
